export default __webpack_public_path__ + "static/media/img-0140-germany-premium-face.73f05d71.png";